import { fromJS } from 'immutable';

import { FETCH_ITEM_TYPES_SUCCESS, FETCH_ITEM_TYPES_FAILED } from '../actions/itemtypes';

const initialState = fromJS({
  itemTypes: {},
  loading: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_ITEM_TYPES_SUCCESS:
      return state.set('itemTypes', fromJS(action.itemTypes)).set('loading', false);
    case FETCH_ITEM_TYPES_FAILED:
      return state.set('error', action.error).set('loading', false);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/itemtypes.js